<template>
  <div class="box box-primary direct-chat">
    <div class="box-header with-border">
      <i class="fa fa-file-text"></i>
      <h3 class="box-title">Notes</h3>
      <div class="box-tools pull-right">
        <span data-toggle="tooltip" :title="notes.length" class="badge bg-success">{{notes.length}}</span>
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="box-body" id="chat-box">
      <div class="direct-chat-messages">
        <template v-for="note in notes">
          <div class="item">
            <template v-if="edit[note.id]">
              <textarea class="form-control" placeholder="Notizeintrag..." v-model="note.original_message"></textarea>
              <div class="clearfix margin"></div>
              <button @click="sendData('PUT', note)" type="button" class="btn btn-sm btn-success"><i class="fa fa-save mr-5"></i>{{'submit' | translate}}</button>
            </template>
            <template v-else>
              <p>
                <strong>{{note.author}}</strong>
                <span class="small text-muted pull-right">{{note.created_at | orderDate}} <i class="fa fa-clock-o mr-5 ml-5"></i>{{note.created_at | orderDate(true)}}</span>
              <div class="small mb-10"><template v-for="line in note.note">{{line}}<br/></template></div>
              <br/>
              <span class="italic" v-if="note.updated_by !== note.author || note.updated_by !== ''"><small>{{'last_edited_by' | translate}}: {{note.updated_by}} ({{note.updated_at | orderDate}} - {{note.updated_at | orderDate(true)}})</small>
                </span>
              </p>
              <button class="btn btn-default btn-sm" @click="editNote(note.id)"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</button>
            </template>
          </div>
          <hr v-if="notes.length > 1">
        </template>
      </div>
    </div>
    <div class="box-footer">
      <label>Neue Notiz</label>
      <textarea class="form-control" placeholder="Notizeintrag..." rows="6" cols="50" v-model="noteBody"></textarea>
      <div class="clearfix margin"></div>
      <button @click="sendData('POST')" type="button" class="btn btn-sm btn-success"><i class="fa fa-save mr-5"></i>{{'submit' | translate}}</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['id', 'reload'],
  data () {
    return {
      notes: [],
      edit: [],
      noteBody: ''
    }
  },
  methods: {
    sendData (method, data = {note: this.noteBody}) {
      let extra = ''
      if (method === 'PUT') {
        extra = `/${data.id}`
        data.note = data.original_message
      }
      API({method: method, url: `orders/${this.id}/notes${extra}`, data: data})
        .then(response => {
          this.getNotes(method === 'PUT' ? data.id : true)
        })
    },
    editNote (noteId) {
      this.edit[noteId] = true
      this.edit = [...this.edit]
    },
    getNotes (flag) {
      this.noteBody = ''
      API.get(`orders/${this.id}/notes`)
        .then(response => {
          this.notes = response.data
          if (flag) {
            this.edit[flag] = false
            this.notes.forEach(n => {
              n.original_message = n.note
              n.note = n.note.split('\n')
            })
          } else {
            this.notes.forEach(n => {
              self.edit[n.id] = false
              n.original_message = n.note
              n.note = n.note.split('\n')
            })
          }
        })
    }
  },
  mounted () {
    this.getNotes(true)
  },
  watch: {
    reload () {
      this.getNotes(true)
    }
  }
}
</script>
<style scoped>
  .italic {
    font-style: italic;
  }
  .direct-chat-messages {
    height: 250px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/OrderNotes.vue